<div class="min-h-svh bg-slate-50/50 dark:bg-gray-900 flex items-center justify-center p-6 transition-colors duration-500">
  <div class="max-w-md w-full text-center animate-in fade-in zoom-in duration-500">

    <div class="relative mx-auto w-24 h-24 mb-8">
      <div class="absolute inset-0 bg-indigo-50 dark:bg-indigo-500/10 rounded-[2rem] animate-pulse border border-indigo-100/60 dark:border-indigo-500/20"></div>
      <div class="relative flex items-center justify-center h-full text-indigo-600 dark:text-indigo-400 text-4xl">
        <i class="fa-solid fa-screwdriver-wrench"></i>
      </div>
    </div>

    <h1 class="text-3xl font-black text-slate-900 dark:text-slate-50 tracking-tight mb-4">
      Lavori in corso su Blinth
    </h1>

    <p class="text-slate-600 dark:text-slate-400 leading-relaxed mb-10">
      Stiamo aggiornando la piattaforma per offrirti nuove funzionalità. Il servizio tornerà disponibile tra pochissimo.
      <span class="block mt-2 font-bold text-slate-800 dark:text-slate-200">I tuoi dati sono al sicuro.</span>
    </p>

    <div class="bg-white dark:bg-slate-900/50 border border-slate-200/80 dark:border-white/5 rounded-3xl p-6 shadow-sm shadow-slate-900/5 mb-10">
      <div class="flex items-center justify-center gap-3 text-xs font-bold text-slate-500 dark:text-slate-500 uppercase tracking-[0.2em]">
        <span class="relative flex h-2.5 w-2.5">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
        </span>
        Stato: In Manutenzione
      </div>
    </div>

    <div class="space-y-4">
      <p class="text-[10px] font-black text-slate-400 dark:text-slate-600 uppercase tracking-[0.3em]">Hai un'urgenza?</p>
      <a href="mailto:supporto&#64;blinth.it"
         class="inline-flex items-center gap-2 text-indigo-600 dark:text-indigo-400 font-bold hover:text-indigo-500 dark:hover:text-indigo-300 transition-colors">
        <i class="fa-solid fa-envelope text-sm"></i>
        supporto&#64;blinth.it
      </a>
    </div>

    <div class="mt-20 text-slate-400 dark:text-slate-700 text-[10px] font-bold uppercase tracking-widest">
      &copy; 2026 Blinth &bull; Gestione Operativa
    </div>

  </div>
</div>
